import { render, staticRenderFns } from "./genouillere.vue?vue&type=template&id=68212ca5"
import script from "./genouillere.vue?vue&type=script&lang=js"
export * from "./genouillere.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports